module.exports = __webpack_public_path__ + "596a4ce9dbeed2a539f10bd9550b5332.svg";